import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { AlertTriangle, Home, ArrowRight } from 'lucide-react';
import { COMPANY_INFO } from '../data';

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>404: Siden blev ikke fundet | VHMU</title>
        <meta name="description" content="Siden du leder efter findes desværre ikke. Find vores udvalg af lifte, kraner og maskiner på forsiden hos Vesthimmerlands Materieludlejning." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <section className="flex min-h-[70vh] flex-col items-center justify-center px-4 py-16 text-center md:px-6 bg-brand-light">
        <div className="rounded-full bg-brand-yellow/10 p-6 text-brand-yellow mb-6 animate-pulse">
          <AlertTriangle className="h-16 w-16" />
        </div>
        <h1 className="text-5xl font-extrabold uppercase tracking-tight text-white sm:text-6xl">
          404 - Siden blev <span className="text-brand-yellow">ikke fundet</span>
        </h1>
        <p className="mt-4 max-w-md text-lg text-gray-400">
          Beklager, men den side du leder efter findes desværre ikke, eller er blevet flyttet.
        </p>

        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Link
            to="/"
            className="flex w-full items-center justify-center gap-2 rounded-md bg-brand-yellow px-6 py-3.5 text-sm font-bold uppercase tracking-wider text-white hover:bg-brand-yellow-hover transition-all duration-200 sm:w-auto"
          >
            <Home className="h-4 w-4" />
            <span>Gå til forsiden</span>
          </Link>
          <a
            href="https://vesthimmerlands.brukerweb.no/product/index/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex w-full items-center justify-center gap-2 rounded-md border border-brand-grey bg-brand-dark px-6 py-3.5 text-sm font-bold uppercase tracking-wider text-white hover:bg-brand-light hover:border-brand-yellow transition-all duration-200 sm:w-auto"
          >
            <span>Se produktkatalog</span>
            <ArrowRight className="h-4 w-4 text-brand-yellow" />
          </a>
        </div>
      </section>
    </>
  );
}
